import { render } from "./EditQuestionFlashPackage.vue?vue&type=template&id=dbc6dd3c&scoped=true"
import script from "./EditQuestionFlashPackage.vue?vue&type=script&lang=js"
export * from "./EditQuestionFlashPackage.vue?vue&type=script&lang=js"

import "./EditQuestionFlashPackage.vue?vue&type=style&index=0&id=dbc6dd3c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbc6dd3c"]])

export default __exports__